// extracted by mini-css-extract-plugin
export default {"htmlContentBox":"email_htmlContentBox__PQzW6","customInputWithScrollbar":"email_customInputWithScrollbar__qlsKs"};